export function toMinutes(hhmm) {
    if (!hhmm || typeof hhmm !== 'string') return NaN;
    const [hStr = '0', mStr = '0'] = hhmm.split(':');
    const h = parseInt(hStr, 10);
    const m = parseInt(mStr, 10);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return NaN;
    return h * 60 + m;
}
